import { Colors } from "./types";

export const baseColors = {
  failure: "#ED4B9E",
  primary: "#209950", // GroveX Green from brand guidelines
  primaryBright: "#d87e2b", // Orange accent from brand guidelines
  primaryDark: "#041576", // Deep navy blue from brand guidelines
  secondary: "#041576", // Deep navy blue from brand guidelines
  success: "#209950", // GroveX Green from brand guidelines
  warning: "#d87e2b", // Orange accent from brand guidelines
};

export const additionalColors = {
  binance: "#d87e2b", // Orange accent from brand guidelines
  overlay: "#01051d", // Deepest navy from brand guidelines
  gold: "#d87e2b", // Orange accent from brand guidelines
  silver: "#B2B2B2",
  bronze: "#d87e2b", // Orange accent from brand guidelines
  groveGreen: "#209950", // GroveX Green from brand guidelines
  groveBlue: "#041576", // Deep navy blue from brand guidelines
  groveDark: "#01051d", // Deepest navy from brand guidelines
};

export const lightColors: Colors = {
  ...baseColors,
  ...additionalColors,
  background: "#FAF9FA",
  backgroundDisabled: "#E9EAEB",
  backgroundAlt: "#FFFFFF",
  backgroundAlt2: "rgba(255, 255, 255, 0.7)",
  cardBorder: "#E7E3EB",
  contrast: "#191326",
  dropdown: "#F6F6F6",
  dropdownDeep: "#EEEEEE",
  invertedContrast: "#FFFFFF",
  input: "#eeeaf4",
  inputSecondary: "#d7caec",
  tertiary: "#EFF4F5",
  text: "#280D5F",
  textDisabled: "#BDC2C4",
  textSubtle: "#7A6EAA",
  disabled: "#E9EAEB",
  gradients: {
    bubblegum: "linear-gradient(139.73deg, #E5FDFF 0%, #F3EFFF 100%)",
    inverseBubblegum: "linear-gradient(139.73deg, #F3EFFF 0%, #E5FDFF 100%)",
    cardHeader: "linear-gradient(111.68deg, #F2ECF2 0%, #E8F2F6 100%)",
    blue: "linear-gradient(180deg, #209950 0%, #041576 100%)",
    violet: "linear-gradient(180deg, #041576 0%, #020827 100%)",
    violetAlt: "linear-gradient(180deg, #041576 0%, #209950 100%)",
    gold: "linear-gradient(180deg, #d87e2b 0%, #209950 100%)",
  },
};

export const darkColors: Colors = {
  ...baseColors,
  ...additionalColors,
  secondary: "#209950", // GroveX Green from brand guidelines
  background: "#01051d", // Deepest navy from brand guidelines
  backgroundDisabled: "#020827", // Dark navy from brand guidelines
  backgroundAlt: "#04104e", // Medium navy from brand guidelines
  backgroundAlt2: "rgba(4, 16, 78, 0.8)", // Medium navy with opacity
  cardBorder: "#041576", // Deep navy from brand guidelines
  contrast: "#FFFFFF",
  dropdown: "#04104e", // Medium navy from brand guidelines
  dropdownDeep: "#01051d", // Deepest navy from brand guidelines
  invertedContrast: "#01051d", // Deepest navy from brand guidelines
  input: "#041576", // Deep navy from brand guidelines
  inputSecondary: "#04104e", // Medium navy from brand guidelines
  primaryDark: "#041576", // Deep navy from brand guidelines
  tertiary: "#041576", // Deep navy from brand guidelines
  text: "#FFFFFF",
  textDisabled: "#6B7280",
  textSubtle: "#9CA3AF",
  disabled: "#374151",
  gradients: {
    bubblegum: "radial-gradient(ellipse at top, #04104e 0%,  #020827 100%)",
    inverseBubblegum: "radial-gradient(ellipse at bottom,  #01051d 0%, #04104e 100%)",
    cardHeader: "linear-gradient(135deg, #04104e 0%, #209950 50%,  #01051d 100%)",
    blue: "radial-gradient(circle at center,  #01051d 0%, #04104e 70%, #01051d 100%)",
    violet: "radial-gradient(circle at center,  #01051d 0%, #020827 70%, #01051d 100%)",
    violetAlt: "linear-gradient(135deg, #04104e 0%, #209950 50%,  #01051d 100%)",
    gold: "radial-gradient(circle at center, #d87e2b 0%, #209950 70%,  #01051d 100%)",
  },
};
